export default "__VITE_ASSET__YukFBoif__"